import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import autodeskLogo from '../../public/autodesk-logo.svg';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, } from '@mui/material';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import ExtensionIcon from '@mui/icons-material/Extension';
import InsightsIcon from '@mui/icons-material/Insights';
import SettingsIcon from '@mui/icons-material/Settings';
import { Typography, Box, Divider, Container } from '@weave-mui/material';
import UserMenu from './UserMenu';
import { useAuth } from '../auth/AuthProvider';
const DRAWER_WIDTH = 240;
const NAV_ITEMS = [
    { label: 'Tasks', path: '/', icon: _jsx(ViewKanbanIcon, {}) },
    { label: 'Scheduled Tasks', path: '/schedules', icon: _jsx(CalendarMonthIcon, {}) },
    { label: 'Agents', path: '/agents', icon: _jsx(SmartToyIcon, {}) },
    { label: 'Skills', path: '/skills', icon: _jsx(ExtensionIcon, {}) },
    { label: 'Analytics', path: '/analytics', icon: _jsx(InsightsIcon, {}) },
    { label: 'Settings', path: '/settings', icon: _jsx(SettingsIcon, {}) },
];
/**
 * Main shell: fixed AppBar, permanent drawer, content + footer (aligned with pim-db-migration-admin).
 */
export default function Layout() {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();
    const handleNavigation = (path) => {
        void navigate(path);
    };
    return (_jsxs(Box, { sx: { display: 'flex', minHeight: '100vh' }, children: [_jsx(AppBar, { position: "fixed", sx: { zIndex: (t) => t.zIndex.drawer + 1, displayPrint: 'none' }, children: _jsxs(Toolbar, { children: [_jsxs(Box, { sx: {
                                display: 'flex',
                                alignItems: 'center',
                                flexGrow: 1,
                                gap: 3,
                                minWidth: 0,
                            }, children: [_jsx(Box, { component: "img", src: autodeskLogo, alt: "Autodesk", sx: {
                                        height: 24,
                                        width: 24,
                                        flexShrink: 0,
                                        cursor: 'pointer',
                                        filter: 'brightness(0)',
                                    }, onClick: () => handleNavigation('/') }), _jsx(Typography, { variant: "h6", noWrap: true, component: "div", onClick: () => handleNavigation('/'), sx: { flexGrow: 1, fontWeight: 600, cursor: 'pointer', minWidth: 0 }, children: "Agent Tasks" })] }), user && (_jsx(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.5 }, children: _jsx(UserMenu, {}) }))] }) }), _jsxs(Drawer, { variant: "permanent", sx: {
                    width: DRAWER_WIDTH,
                    flexShrink: 0,
                    displayPrint: 'none',
                    '& .MuiDrawer-paper': {
                        width: DRAWER_WIDTH,
                        boxSizing: 'border-box',
                    },
                }, children: [_jsx(Toolbar, {}), _jsx(Divider, {}), _jsx(List, { sx: { pt: 1 }, children: NAV_ITEMS.map((item) => (_jsx(ListItem, { disablePadding: true, sx: { mb: 0.5 }, children: _jsxs(ListItemButton, { selected: location.pathname === item.path ||
                                    (item.path !== '/' && location.pathname.startsWith(`${item.path}/`)), onClick: () => handleNavigation(item.path), children: [_jsx(ListItemIcon, { sx: { minWidth: 40 }, children: item.icon }), _jsx(ListItemText, { primary: item.label, primaryTypographyProps: { fontSize: '0.9rem', fontWeight: 500 } })] }) }, item.path))) })] }), _jsxs(Box, { component: "main", sx: {
                    flexGrow: 1,
                    minWidth: 0,
                    overflow: 'hidden',
                    bgcolor: 'background.default',
                    p: 3,
                    minHeight: '100vh',
                    pb: '48px',
                }, children: [_jsx(Toolbar, { sx: { displayPrint: 'none' } }), _jsx(Container, { maxWidth: "xl", children: _jsx(Outlet, {}) })] }), _jsx(Box, { component: "footer", sx: {
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'background.paper',
                    borderTop: 1,
                    borderColor: 'divider',
                    zIndex: (t) => t.zIndex.drawer,
                    displayPrint: 'none',
                }, children: _jsx(Typography, { variant: "caption", color: "text.secondary", children: "\u00A9 Copyright 2026 Autodesk, Inc. All rights reserved." }) })] }));
}
